import React from 'react';

import { CONNECTION_STATUS } from '../constants';
// Once the @minervaproject/fds library is integrated into this project, the
// below div should be converted to a <Alert kind="error"> component.
export const ErrorBanner = ({ connectionStatus }) => {
  if (!connectionStatus || connectionStatus === CONNECTION_STATUS.ok) {
    return null;
  }
  return (
    <div
      className="top-0 right-0 left-0 fixed flex justify-center"
      style={{ zIndex: 1000 }}
    >
      <div
        className="m3 px3 py2 bg-red-tint-90 secondary-font border"
        style={{ borderColor: '#D26055', borderRadius: '4px' }}
      >
        <b>Forum has lost connection to the internet. </b>
        {connectionStatus === CONNECTION_STATUS.delayed ? (
          <>
            Please check your computer's internet connection while we try
            reconnecting.
          </>
        ) : (
          <>
            Please check your computer's internet connection and refresh the
            page.
          </>
        )}
      </div>
    </div>
  );
};
